import Box from 'components/shared/Box'
import SinglePhoto from 'components/shared/Gallery/SinglePhoto'
import IconWithText from 'components/shared/IconWithText'
import Modal from 'components/shared/Modal'
import Text from 'components/shared/Text'
import { defineMessage, FormattedMessage, useIntl } from 'react-intl'

import busPhoto from 'assets/images/transport/busPhoto.jpg'
import busPhotoMobile from 'assets/images/transport/busPhoto_mobile.jpg'

import List from 'components/shared/List'
import { useResolutions } from 'store/resolutions'
import { TransportModalBody } from 'routes/Upsell/styles'
import { guidelinesData, infoIconsData } from './data'
import { UpsellModalProps } from 'routes/Upsell/types'

export const TransportModal = ({ isOpened, closeModal }: UpsellModalProps) => {
    const { formatMessage } = useIntl()
    const { isMobile } = useResolutions()

    return (
        <Modal
            isOpened={isOpened}
            maxWidth={670}
            onClose={closeModal}
            isMobileFullscreen={true}
            hasGlobalHeader
            headerMessage={
                <FormattedMessage
                    id="upsells.transport.modal_heading"
                    defaultMessage="Transport autokarowy"
                />
            }
            testIdPrefix="transport-box-about"
        >
            <TransportModalBody
                pt={[24, 40]}
                pl={[16, 40]}
                pr={[16, 40]}
                pb={[24, 40]}
                gap={32}
            >
                {/* main picture */}
                <SinglePhoto
                    photoPath={!isMobile ? busPhoto : busPhotoMobile}
                    alt="Suntago Bus"
                    isFullWidth
                />
                {/* advantages with info icons */}
                <Box
                    isFullWidth
                    justify="space-between"
                    direction={['column', 'row']}
                    gap={[22, 28]}
                >
                    {infoIconsData.map(({ icon, iconAlt, text }) => (
                        <IconWithText
                            icon={icon}
                            iconAlt={iconAlt}
                            textHighlighted={formatMessage(text)}
                            fontVariant="bodySmall"
                            gap={12}
                            key={iconAlt}
                        />
                    ))}
                </Box>
                {/* things to remember */}
                <Box gap={8} direction="column">
                    <Text variant="heading4" mb={8}>
                        <FormattedMessage
                            id="upsells.transport.modal_guidelines_caption"
                            defaultMessage="Pamiętaj!"
                        />
                    </Text>
                    <List gap={8}>
                        {guidelinesData.map((guideline) => (
                            <FormattedMessage
                                {...defineMessage(guideline)}
                                key={guideline.id}
                            />
                        ))}
                    </List>
                    <Text
                        variant="bodySmall"
                        color="grayscale_900"
                        style={{ marginTop: '16px', opacity: 0.8 }}
                    >
                        <FormattedMessage
                            id="upsells.transport.modal_guidelines_additional_info"
                            defaultMessage="*Przy zakupie biletów na przejazd online."
                        />
                    </Text>
                </Box>
            </TransportModalBody>
        </Modal>
    )
}

TransportModal.displayName = 'TransportModal'
